import { Spinner, Typography } from '@tempmee/react';
import {
  Center,
  Column,
  FloatingContainer,
  Pagination,
  Screen,
} from '~/commonComponents';
import {
  IDraftJobPostListViewEntity,
  IJobPostEntity,
  JobPostingStatus,
} from '~/domain/PermanentJobs';
import { DefaultTable, DraftTable, Header, SuspendedBanner } from './components';
import { useManageJobs } from './useManageJobs';

export const ManageJobs = () => {
  const {
    data, forms, initialStatus, isInitialLoading,
    isLoading, methods, pagination, statistics,
  } = useManageJobs();

  const isDraft = forms.filters.status === JobPostingStatus.Draft;

  return (
    <>
      <Screen>
        <FloatingContainer borderRadius={0} paddingBlock={48} paddingInline={16} height="100%">
          <Typography as="span" bold size="heading_2" textAlign="center">
            Permanent Jobs
          </Typography>
          <SuspendedBanner counts={statistics.tabs.suspended} style={{ marginTop: 24 }} />
          <Header
            initialStatus={initialStatus}
            statistics={statistics.tabs}
            onValueChanges={(newValue) => {
              methods.setFormFilters(newValue);
              methods.setCurrentPage(1);
            }}
          />
          <Column paddingInline={72}>
            {isInitialLoading ? (
              <Center marginBlock={32}>
                <Spinner centered variant="default" size="md" />
              </Center>
            ) : (
              <>
                {!isDraft ? (
                  <DefaultTable
                    data={data as IJobPostEntity[]}
                    formSorting={forms.sorting}
                    isLoading={isLoading}
                    onSortChanges={methods.setFormSorting}
                  />
                ) : (
                  <DraftTable data={data as IDraftJobPostListViewEntity[]} isLoading={isLoading} />
                )}
                <Pagination
                  currentPage={pagination.currentPage}
                  totalPages={pagination.totalPages}
                  onPageChange={methods.setCurrentPage}
                />
              </>
            )}
          </Column>
        </FloatingContainer>
      </Screen>
    </>
  );
};
